import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ClientDTO, Role } from '../../models/models.swagger.generated';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { ClientService } from '../../services/client/client.service';
import { DropDownConstantsFactory } from '../../shared/syncfusion/dropdown-constants-factory';
import { TranslateModule } from '@ngx-translate/core';
import { YesNoGroupButtonComponent } from '../../shared/yes-no-group-button/yes-no-group-button.component';
import { ClientAutocompleteComponent } from '../../shared/client-autocomplete/client-autocomplete.component';
import { PasswordInputComponent } from '../../shared/password-input/password-input.component';
import { AppErrorMessagesComponent } from '../../error-messages/app-error-messages.component';
import { NgClass } from '@angular/common';
import { UserEditFormGroup } from '../user-edit-form/user-edit-form-type';

@Component({
    selector: 'app-tpu-edit-form',
    templateUrl: './third-party-user-edit-form.component.html',
    styleUrls: ['./third-party-user-edit-form.component.scss'],
    imports: [ReactiveFormsModule, NgClass, AppErrorMessagesComponent, PasswordInputComponent, ClientAutocompleteComponent, YesNoGroupButtonComponent, TranslateModule]
})
export class ThirdPartyUserEditFormComponent implements OnInit, OnDestroy {
  @Input() public thirdPartyUserEditForm: UserEditFormGroup;
  @Input() public selectedClientId: number | null | undefined = null;

  public get clients(): ClientDTO[] {
    return this.clientService.clients;
  }

  public get isLoggedInUser(): boolean {
    return this.thirdPartyUserEditForm.value.userId === this.authService.getUserInfo().userId;
  }

  public isAdd: boolean;
  public initialRole: Role;
  public dropdownSettings = DropDownConstantsFactory.createStandardClientDropdownSettings();

  private subscriptions = new Subscription();

  constructor(private authService: AuthService,
    private clientService: ClientService) { }

  ngOnInit(): void {
    this.isAdd = !this.thirdPartyUserEditForm.value.userId;
    this.initialRole = this.thirdPartyUserEditForm.value.role;
    this.loadClients();
    if (this.isAdd) {
      this.subscriptions.add(this.thirdPartyUserEditForm.controls.client.valueChanges.subscribe(client => {
        if (client) {
          this.thirdPartyUserEditForm.controls.userName.setValue((client.clientIdent ?? '') + this.thirdPartyUserEditForm.controls.firstname.value + '_' + this.thirdPartyUserEditForm.controls.lastname.value);
        } else {
          this.thirdPartyUserEditForm.controls.userName.setValue(null);
        }
      }));
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public hideClient() {
    return this.authService.getUserInfo().clientId || this.isLoggedInUser;
  }

  private getClientById(id: number): ClientDTO {
    return id ? this.clients?.find(c => c.id === id) : null;
  }

  private loadClients() {
    const loggedInUser = this.authService.getUserInfo();
    if (loggedInUser.client != null) {
      this.thirdPartyUserEditForm.controls.client.setValue(loggedInUser.client);
    }
    else {
      // patch client to the form if required
      if (this.thirdPartyUserEditForm.value.client && this.thirdPartyUserEditForm.value.client.id) {
        this.thirdPartyUserEditForm.controls.client.setValue(this.getClientById(this.thirdPartyUserEditForm.value.client.id));
      } else if (this.isAdd) {
        this.thirdPartyUserEditForm.controls.client.setValue(this.getClientById(this.selectedClientId));
      }
    }
  }

}
